import React from "react";
import ButtonSpinner from "../../controls/ButtonSpinner";

const VARIANTS = {
  classic: {
    wrapper: "flex flex-shrink-0 justify-end px-4 py-4",
    cancel:
      "rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400",
    submit:
      "ml-4 inline-flex items-center justify-center rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:cursor-not-allowed disabled:opacity-50",
  },
  modern: {
    wrapper: "flex shrink-0 justify-end gap-3 px-4 py-4 sm:px-6",
    cancel:
      "rounded-xl border border-[#E2E8F0] bg-white px-4 py-2 text-sm font-semibold text-[#0F172A]",
    submit:
      "inline-flex items-center justify-center rounded-xl border border-[#2563EB] bg-[#2563EB] px-4 py-2 text-sm font-semibold text-white disabled:cursor-not-allowed disabled:opacity-50",
  },
};

type SetupSlideOverFormActionsProps = {
  setOpen: (state: { childComponent: null; open: boolean }) => void;
  isEdit?: boolean;
  submitting?: boolean;
  formId?: string;
  onSubmit?: (e: React.FormEvent) => void;
  variant?: "classic" | "modern";
  submitLabel?: string;
  submittingLabel?: string;
};

export default function SetupSlideOverFormActions({
  setOpen,
  isEdit = false,
  submitting = false,
  formId,
  onSubmit,
  variant = "classic",
  submitLabel,
  submittingLabel,
}: SetupSlideOverFormActionsProps) {
  const styles = VARIANTS[variant] ?? VARIANTS.classic;
  const idleLabel = submitLabel ?? (isEdit ? "Save" : "Create");
  const loadingLabel =
    submittingLabel ?? (isEdit ? "Saving..." : "Creating...");

  const closeSlideOver = () => setOpen({ childComponent: null, open: false });

  return (
    <div className={styles.wrapper}>
      <button type="button" className={styles.cancel} onClick={closeSlideOver}>
        Cancel
      </button>
      <button
        type={formId ? "submit" : "button"}
        form={formId}
        className={styles.submit}
        disabled={submitting}
        onClick={formId ? undefined : onSubmit}
      >
        {submitting ? (
          <>
            <ButtonSpinner spin={true} />
            {loadingLabel}
          </>
        ) : (
          idleLabel
        )}
      </button>
    </div>
  );
}
